import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  href?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'lg',
  href,
  fullWidth = false,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1';
  const variants = {
    primary: 'bg-[#16A34A] text-white hover:bg-[#15803d] ring-4 ring-green-500/30',
    secondary: 'bg-[#F59E0B] text-[#1E3A5F] hover:bg-[#D97706] ring-4 ring-amber-500/30',
    outline: 'bg-transparent border-2 border-[#1E3A5F] text-[#1E3A5F] hover:bg-[#1E3A5F] hover:text-white shadow-none hover:shadow-md'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg md:text-xl',
    xl: 'px-10 py-5 text-xl md:text-2xl'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const combinedClasses = `${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`;
  const handleClick = (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    if (href && href.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    if (onClick) {
      onClick(e as any);
    }
  };
  if (href && !href.startsWith('#')) {
    return <motion.a whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} href={href} className={combinedClasses} onClick={handleClick} data-id="element-359">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={combinedClasses} onClick={handleClick} {...props} data-id="element-360">
      {children}
    </motion.button>;
}